<template>
  <div style="position: absolute; top: 0; left: 0; right: 0">
    <v-progress-linear color="grey-darken-4" indeterminate></v-progress-linear>
  </div>
</template>
